import SandboxClient, { TestResultsResponse } from './SandboxClient';
import HttpClient from '../../gateway/HttpClient';
import HttpMethod from '../../constant/HttpMethod';
import { SandboxMethods } from '../../constant/MethodNames';
import { CancelToken } from 'axios';

class NestSandboxClient implements SandboxClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public async importFromJson(): Promise<any> {
    return Promise.resolve(undefined);
  }

  public async getElasticHistory(dto: any): Promise<any> {
    return await this.httpClient.execute(HttpMethod.POST, `${SandboxMethods.GET_ELASTIC_HISTORY}`, dto);
  }

  public async importFromCsv(): Promise<any> {
    return Promise.resolve(undefined);
  }

  public async send(): Promise<any> {
    return Promise.resolve(undefined);
  }

  public async sendElasticHistory(): Promise<any> {
    return Promise.resolve(undefined);
  }

  public async sendEventFromCsv(): Promise<any> {
    return Promise.resolve(undefined);
  }

  public async sendEventFromJson(): Promise<any> {
    return Promise.resolve(undefined);
  }

  public async sendHistorical(channel: string, date: { from: number; to: number }, rules: string[], token?: CancelToken): Promise<any> {
    const dto = { channel, date, rules };
    return this.httpClient.execute(HttpMethod.POST, SandboxMethods.SEND_HISTORICAL, dto, undefined, undefined, undefined, token);
  }

  public async testResults(): Promise<TestResultsResponse[]> {
    return this.httpClient.execute(HttpMethod.GET, SandboxMethods.TEST_RESULTS);
  }
}

export default NestSandboxClient;
